import { Typography, makeStyles } from "@material-ui/core"
import { RoleCountPill } from "./RoleCountPill"
import { HourReportingRolesTranslations } from "../hooks/use-translations"
import type { MemberSummary } from "../../../../memberships/api/hour-reporter-membership"

type MemberIdentityProps = {
  member: MemberSummary
  checkerCount: number
  approverCount: number
  translations: HourReportingRolesTranslations
  supportsChecking: boolean
  onOpenRoleDetails: () => void
}

export const MemberIdentity = ({
  member,
  checkerCount,
  approverCount,
  translations,
  supportsChecking,
  onOpenRoleDetails,
}: MemberIdentityProps) => {
  const classes = useStyles()

  return (
    <div>
      <Typography variant="subtitle2" component="p" className={classes.memberName}>
        {member.fullname}
      </Typography>
      <Typography variant="body2" component="p" color="textSecondary">
        {member.userEmail}
      </Typography>
      <div className={classes.memberRoleCounts}>
        {supportsChecking && (
          <RoleCountPill
            roleType="checker"
            count={checkerCount}
            label={translations.checkerCountLabel}
            iconName="data_check"
            onClick={onOpenRoleDetails}
          />
        )}
        <RoleCountPill
          roleType="approver"
          count={approverCount}
          label={translations.approverCountLabel}
          iconName="verified"
          onClick={onOpenRoleDetails}
        />
      </div>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  memberName: {
    fontWeight: 600,
  },
  memberRoleCounts: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(0.75),
    marginTop: theme.spacing(1),
  },
}))
